import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ap-button-skeleton',
    templateUrl: './button-skeleton.component.html',
    styleUrls: ['./button-skeleton.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApButtonSkeletonComponent {}
